// https://fffptc.atlassian.net/browse/RET-1541
// a-f brightness is greater than 150 and g-l brightness is lower than 150
const COLOR_BREAK_POINT = 150;

interface HexToRgb {
  r: number;
  g: number;
  b: number;
}

const hexToRgb = (hexadecimalColor: string): HexToRgb | null => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexadecimalColor);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

const getBrightness = (hexadecimalColor: string | undefined): number => {
  if (!hexadecimalColor) return 0;
  //http://www.w3.org/TR/AERT#color-contrast
  const rgb = hexToRgb(hexadecimalColor);
  if (!rgb) return 0;
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
};

export { hexToRgb, getBrightness, COLOR_BREAK_POINT };
